module.exports = __webpack_public_path__ + "media/assets/site_images/harvest-802cd88bdf80e9f34be41769c4d5832c.jpg";